import React from 'react'
import { Outlet } from 'react-router-dom';

const Industries = () => {
  return (
    <div>
      <h1>Our Industries</h1>
      <Outlet />
    </div>
  )
}

export default Industries
